var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { StyleSheet, TouchableOpacity, } from 'react-native';
import { useDebounceFn } from '../../hooks/useDebounceFn';
import { useDeepMemo } from '../../hooks/useDeepMemo';
import { styles } from '../../utils/style';
import { Box } from '../Box';
const styleFlex = {
    flexCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    flexRowBtw: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    flexRowCenter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    flexCol: {
        display: 'flex',
        flexDirection: 'column',
    },
    flexColBtw: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    flexColCenter: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
};
export function Flex(props) {
    const _a = props || {}, { flex, children, style: outerStyle, touchableOpacityStyle, activeOpacity = 0.4, onPress, bs, wait } = _a, rest = __rest(_a, ["flex", "children", "style", "touchableOpacityStyle", "activeOpacity", "onPress", "bs", "wait"]);
    const style = useDeepMemo(() => {
        var _a;
        const flexs = Array.isArray(props.flex)
            ? props.flex
            : [(_a = props.flex) !== null && _a !== void 0 ? _a : 'flexRow'];
        const styleList = flexs.filter((v) => !!v).map((v) => styleFlex[v]);
        return styles(Object.assign({}, ...styleList));
    }, [flex]);
    const Node = (React.createElement(Box, Object.assign({}, rest, { bs: bs, style: StyleSheet.flatten([style, outerStyle]) }), children));
    const { run: deboundPress } = useDebounceFn((e) => {
        onPress === null || onPress === void 0 ? void 0 : onPress(e);
    }, {
        wait,
        leading: true,
        trailing: false,
    });
    return onPress ? (React.createElement(TouchableOpacity, { style: [touchableOpacityStyle], activeOpacity: activeOpacity, onPress: deboundPress }, Node)) : (Node);
}
export default Flex;
